// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"d8566c07","476":"eb01b0cf","528":"1e476285","720":"62767da3","839":"e2c35f98"}[chunkId] + ".chunk.js";
};